/* Quiet chrome — pure hide/reveal reducer for the auto-hiding fixed
   header. Single source of truth for the hysteresis tunables (night-mode
   convention). Wiring (scroll listener, tab, root class) lives in
   custom.js; this file stays pure so `node --test` can exercise it.
   Spec: docs/superpowers/specs/2026-07-19-quiet-chrome-design.md */
(function () {
  'use strict';

  const HEADER_HIDE = {
    HIDE_AFTER_DOWN: 120, // px cumulative downward scroll before hiding
    REVEAL_AFTER_UP: 8,   // px upward nudge that reveals
    NEAR_TOP: 300         // px scrollY below which the header never hides
  };

  // state = { hidden, downAccum }; frame = { deltaY, scrollY, fixed, overlayOpen }.
  // Never hidden when the header isn't fixed, near the top, or while an
  // overlay is open. downAccum clamps at the threshold; a reveal resets
  // it so the next hide needs a fresh deliberate scroll.
  function headerHideNext(state, frame) {
    const s = state || { hidden: false, downAccum: 0 };
    if (!frame) return s;
    const scrollY = Number(frame.scrollY);
    if (!frame.fixed || frame.overlayOpen ||
        (isFinite(scrollY) && scrollY < HEADER_HIDE.NEAR_TOP)) {
      return { hidden: false, downAccum: 0 };
    }
    const deltaY = Number(frame.deltaY);
    if (!isFinite(deltaY) || deltaY === 0) return s;
    if (deltaY > 0) {
      const accum = Math.min(HEADER_HIDE.HIDE_AFTER_DOWN, s.downAccum + deltaY);
      return { hidden: s.hidden || accum >= HEADER_HIDE.HIDE_AFTER_DOWN, downAccum: accum };
    }
    if (-deltaY >= HEADER_HIDE.REVEAL_AFTER_UP) return { hidden: false, downAccum: 0 };
    return s;
  }

  const api = { HEADER_HIDE: HEADER_HIDE, headerHideNext: headerHideNext };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.HeaderHide = api;
})();
